import React, { useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from '../useAuthhandling';

function News() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [news, setNews] = useState({
    title: "",
    description: "",
    author: "",
    publishDate: "",
    newsImg: "",
    status: true,
  });
  const [formerror, setError] = useState({});

  let name, value;
  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;

    setNews({ ...news, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setNews({ ...news, [name]: e.target.files[0] });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.title) {
      errors.title = "Title is required!";
    }

    if (!values.description) {
      errors.description = "Description is required!";
    }
    if (!values.newsImg) {
      errors.newsImg = "Image is required!";
    } else {
      if (
        values.newsImg.type === "image/jpeg" ||
        values.newsImg.type === "image/jpg" ||
        values.newsImg.type === "image/png"
      ) {
        if (values.newsImg.size > 1024 * 1000) {
          errors.newsImg =
            "maximum file size 1 mb...please upload an image less than 1 mb";
        }
      } else {
        errors.newsImg = "Only support jpg, jpeg, png image!";
      }
    }
    if (!values.publishDate) {
      errors.publishDate = "Date is required!";
    }
    if (!values.author) {
      errors.author = "Author is required!";
    }

    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const { title, description, newsImg, publishDate, author } = news;
    const ress = validate(news);
    setError(ress);
    if (
      !ress.title &&
      !ress.description &&
      !ress.newsImg &&
      !ress.publishDate &&
      !ress.author
    ) {
      const formData = new FormData();
      formData.append("title", news.title);
      formData.append("description", news.description);
      formData.append("author", news.author);
      formData.append("publishDate", news.publishDate);
      formData.append("newsImg", news.newsImg);
      formData.append("status", news.status);

      axios
        .post(`${Config.apiurl}/api/v1/crm/news/create`, formData, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success("Sucessfully Created Account", {
              position: "top-center",
              autoClose: 1500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => navigate("/dashboard"), 3000);
          }
      
          
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            window.alert("error");
          }
          });    
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row grid-margin">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">News Data Table</h4>
                    <form className="forms-sample" onSubmit={PostData}>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1"> Title</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Title"
                          name="title"
                          value={news.title}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.title}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Description"
                          name="description"
                          value={news.description}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.description}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">
                          Created By
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder=" Created By"
                          name="author"
                          value={news.author}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.author}
                        </label>
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Date</label>
                        <input
                          type="date"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Date"
                          name="publishDate"
                          value={news.publishDate}
                          onChange={handleInputs}
                          onClick={(e) => e.target.showPicker()}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.publishDate}
                        </label>
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Image (400px * 340px)
                        </label>
                        <br></br>
                        <input
                          type="file"
                          name="newsImg"
                          onChange={onFileChange}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.newsImg}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Status</label>

                        <select
                          className="form-control"
                          style={{
                            color: "black",
                            backgroundColor: "#2b2e4c;",
                          }}
                          id="exampleInputUsername1"
                          name="status"
                          onChange={handleInputs}
                        >
                          <option
                            id="exampleInputUsername1"
                            name="status"
                            value="true"
                          >
                            true
                          </option>
                          <option
                            id="exampleInputUsername1"
                            name="status"
                            value="false"
                          >
                            false
                          </option>
                        </select>
                      </div>
                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default News;
